import type { CISProviderBehavior } from '../types';
import { formatToMask, matchesMask } from '../../helpers/inputMask';

const CSA_ACCOUNT_NUMBER_PATTERN = '000000-000000';

export const csaCISBehavior: CISProviderBehavior = {
	label: 'CSA',
	accountNumberPattern: CSA_ACCOUNT_NUMBER_PATTERN,
	formatAccountNumber(raw, isDeleting) {
		return formatToMask(raw, CSA_ACCOUNT_NUMBER_PATTERN, isDeleting);
	},
	validateAccountNumber(value) {
		return matchesMask(value, CSA_ACCOUNT_NUMBER_PATTERN);
	},
	getTestPanelConfig() {
		return { show: true, altText: 'CSA' };
	},
};
